export default __webpack_public_path__ + "static/media/books2-afterB-1920w.611b6d80.avif";